module.exports = new __parcel__URL__("opsgenie-left.49c0f64b.svg").toString();